module.exports = __webpack_public_path__ + "img/C04BlotOutTheSun_ua.17e671ea.webp";